import { Omit } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import React, { FunctionComponent } from 'react';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import { spacings } from '../spacings';
import {
  PageHeaderText,
  PageHeaderTextProps,
} from '../TextStyles/PageHeaderText';

interface OwnProps extends Omit<PageHeaderTextProps, 'classes'> {}

interface PageHeaderProps extends OwnProps, WithStyles<typeof styles> {}

const PageHeaderBase: FunctionComponent<PageHeaderProps> = ({
  children,
  classes,
  ...props
}) => (
  <div className={classes.root}>
    <PageHeaderText {...props}>{children}</PageHeaderText>
  </div>
);

// styled
const styles = (theme: Theme) => {
  const {
    page: { top: pageTopSpacing },
  } = spacings(theme);

  return createStyles({
    root: {
      ...pageTopSpacing,
    },
  });
};

const enhance = compose<PageHeaderProps, OwnProps>(
  pure,
  withStyles(styles),
);

/**
 * Page header
 *
 * @zeplin {@link https://zpl.io/bPPR5wA }
 */
export const PageHeader = enhance(PageHeaderBase);

PageHeader.displayName = 'PageHeader';
